/* Quiet Ring — infinite marquee (vanilla port of Marquee.jsx) */
(function () {
  function pendingImages(track) {
    return Array.prototype.slice.call(track.querySelectorAll("img")).filter(function (img) {
      return !img.complete;
    });
  }

  function waitForImages(track, cb) {
    var pending = pendingImages(track);
    if (!pending.length) {
      cb();
      return;
    }
    var done = false;
    var remaining = pending.length;
    function settle() {
      remaining -= 1;
      if (remaining <= 0 && !done) {
        done = true;
        cb();
      }
    }
    pending.forEach(function (img) {
      img.addEventListener("load", settle, { once: true });
      img.addEventListener("error", settle, { once: true });
    });
    // Safety net: a broken/slow image should never freeze the marquee forever.
    window.setTimeout(function () {
      if (!done) {
        done = true;
        cb();
      }
    }, 2500);
  }

  function setupMarquee(container) {
    if (container.dataset.qrMarqueeInit) return;
    container.dataset.qrMarqueeInit = "true";

    var track = container.querySelector(".qr-marquee__track");
    if (!track) return;

    var direction = container.dataset.direction || "left";
    var speed = parseFloat(container.dataset.speed) || 55;
    var pauseOnHover = container.hasAttribute("data-pause-on-hover");
    var baseHTML = track.innerHTML;
    var tween = null;

    function measureAndStart(repeats) {
      var setWidth = track.scrollWidth / repeats;
      if (!setWidth) return;

      var needed = Math.max(2, Math.ceil(container.clientWidth / setWidth) + 1);
      if (needed !== repeats) {
        track.innerHTML = new Array(needed).fill(baseHTML).join("");
        waitForImages(track, function () {
          measureAndStart(needed);
        });
        return;
      }

      if (tween) tween.kill();
      gsap.set(track, { x: direction === "right" ? -setWidth : 0 });
      tween = gsap.to(track, {
        x: direction === "right" ? 0 : -setWidth,
        duration: setWidth / speed,
        ease: "none",
        repeat: -1,
      });

      if (pauseOnHover) {
        container.addEventListener("mouseenter", function () {
          tween.pause();
        });
        container.addEventListener("mouseleave", function () {
          tween.play();
        });
      }
    }

    waitForImages(track, function () {
      measureAndStart(1);
    });
  }

  function initAll() {
    document.querySelectorAll("[data-qr-marquee]").forEach(setupMarquee);
  }

  document.addEventListener("DOMContentLoaded", initAll);
  document.addEventListener("shopify:section:load", initAll);
})();
